const QUESTION_TOGGLE_ID_SUFFIX = '_q-toggle'
const QUESTION_ID_SUFFIX = '_question-container'

const CATEGORY_TOGGLE_ID_SUFFIX = '_c-toggle'
const CATEGORY_TITLE_ID_SUFFIX = '_category-title'

const isToggledQuestionsView = (appPartElm: HTMLDivElement) =>
	!!appPartElm.querySelector(`[id^=${appPartElm.id}_ExpandQuestionsSep_Category]`) ||
	!!appPartElm.querySelector(`[id^=${appPartElm.id}_ToggleMobile2_Category_Mobile]`)

const attachTogglesClickEvent = (
	appPartElm: HTMLDivElement,
	toggleIdSuffix: string,
	clickableElmIdSuffix: string,
	shouldCloseOthers = false
) => {
	appPartElm.querySelectorAll<HTMLDivElement>(`[id$=${toggleIdSuffix}]`).forEach((toggleEl) => {
		const clickableEl = toggleEl.querySelector(`[id$=${clickableElmIdSuffix}]`)!
		clickableEl.addEventListener('click', () => {
			const isCurrentlyOpen = toggleEl.dataset.open === 'true'

			if (!isCurrentlyOpen && shouldCloseOthers) {
				const currentlyOpenToggle = appPartElm.querySelector<HTMLDivElement>(
					`[id$=${toggleIdSuffix}][data-open=true]`
				)
				if (currentlyOpenToggle) {
					currentlyOpenToggle.dataset.open = 'false'
				}
			}

			toggleEl.dataset.open = isCurrentlyOpen ? 'false' : 'true'
		})
	})
}

export const initFAQ = (appPartElm: HTMLDivElement) => {
	const shouldCloseOthers = isToggledQuestionsView(appPartElm)

	attachTogglesClickEvent(appPartElm, QUESTION_TOGGLE_ID_SUFFIX, QUESTION_ID_SUFFIX, shouldCloseOthers)
	attachTogglesClickEvent(appPartElm, CATEGORY_TOGGLE_ID_SUFFIX, CATEGORY_TITLE_ID_SUFFIX)
}
